import { motion } from "framer-motion";

export const ease = [0.22, 1, 0.36, 1];

export const Logo = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="1" y="1" width="62" height="62" rx="14" fill="none" stroke="currentColor" strokeOpacity="0.35" />
    <path d="M16 46V18h3l13 18 13-18h3v28" fill="none" stroke="var(--gold)" strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M16 46h12" stroke="var(--gold)" strokeWidth="2.5" />
    <circle cx="48" cy="46" r="2.5" fill="var(--gold)" />
  </svg>
);

export const Spark = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path d="M12 0c.6 6.4 5.6 11.4 12 12-6.4.6-11.4 5.6-12 12-.6-6.4-5.6-11.4-12-12C6.4 11.4 11.4 6.4 12 0z" fill="currentColor" />
  </svg>
);

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <p className="overline flex items-center gap-3">
    <span className="inline-block w-8 h-px bg-[var(--gold)]" />
    {children}
  </p>
);

const lineV = {
  hidden: { y: "110%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, delay: d, ease } }),
};

export const MaskLines = ({ lines, italicIndex = -1, delay = 0, inView = false, className = "" }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" })}
  >
    {lines.map((l, i) => (
      <span key={l + i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${i === italicIndex ? "italic text-[var(--gold)]" : ""}`}
          variants={lineV}
          custom={delay + i * 0.12}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);
